module.exports = __webpack_public_path__ + "img/about_2_2.97c04faf.jpg";